import { render } from "./intermediaries.configuration.vue?vue&type=template&id=346dc133"
import script from "./intermediaries.configuration.vue?vue&type=script&lang=js"
export * from "./intermediaries.configuration.vue?vue&type=script&lang=js"

import "./intermediaries.configuration.vue?vue&type=style&index=0&id=346dc133&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__